import { render, staticRenderFns } from "./FutureValue.vue?vue&type=template&id=6bb405ed&scoped=true&"
import script from "./FutureValue.vue?vue&type=script&lang=js&"
export * from "./FutureValue.vue?vue&type=script&lang=js&"
import style0 from "./FutureValue.vue?vue&type=style&index=0&id=6bb405ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb405ed",
  null
  
)

export default component.exports